import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import redCardImg from "../../assets/redCard.png";
import yellowRedCardImg from "../../assets/yellowRedCard.png";
import goalsImg from "../../assets/scorer.png";
import assistImg from "../../assets/assist.png";
import DummyImg from "../../assets/user.png";
import pointsIcon from "../../assets/pointsIcon.png";
import cleenSheetImg from "../../assets/goal-post.png";

import axios from "axios";
import PlayerModal from "../../components/PlayerModal";
//
//
import bellicosaData from "../../data/staticEachTeamData/Bellicosa_FC_players.json";
import carronData from "../../data/staticEachTeamData/Carron_Capitals_players.json";
import feonnaData from "../../data/staticEachTeamData/Feonn_Furies_players.json";
import mangoData from "../../data/staticEachTeamData/Mango_Marvels_players.json";
import sakoriData from "../../data/staticEachTeamData/Sakori_Smashers_players.json";
import sejalData from "../../data/staticEachTeamData/Sejal_Scorchers_players.json";
import sagarData from "../../data/staticEachTeamData/Team_Sagar_players.json";
import vandanaData from "../../data/staticEachTeamData/Vandana_Warriors_players.json";

import bellicosaData2025 from "../../data/Data_2025/staticEachTeamData/Bellicosa_FC_players.json";
import carronData2025 from "../../data/Data_2025/staticEachTeamData/Carron_Capitals_players.json";
import galaLegendsData2025 from "../../data/Data_2025/staticEachTeamData/Gala_Legends_players.json";
import mangoData2025 from "../../data/Data_2025/staticEachTeamData/Mango_Marvels_players.json";
import sakoriData2025 from "../../data/Data_2025/staticEachTeamData/Sakori_Smashers_players.json";
import sejalData2025 from "../../data/Data_2025/staticEachTeamData/Sejal_Scorchers_players.json";
import sagarSeahawksData2025 from "../../data/Data_2025/staticEachTeamData/Sagar_Seahawks_players.json";
import vandanaData2025 from "../../data/Data_2025/staticEachTeamData/Vandana_Warriors_players.json";

function StaticEachTeam() {
  // const val = "teams";
  const [eachteamData, setEachTeamData] = useState();
  const { teamName, topPlayerId } = useParams();
  const [showDetails, setShowDetails] = useState(false);
  const [thisTeamData, setThisTeamData] = useState();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [team_logo, setTeam_logo] = useState(DummyImg);

  // const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const detailsTopPlayer = useRef(null); // Ref to access the <details> element
  const targetRefTopPlayer = useRef(null);

  // Matching teamname with json data
  const location = useLocation();
  const is2025 = location.pathname.startsWith("/teams2025");

  const teamDataMap2024 = {
    bellicosa: bellicosaData,
    carron: carronData,
    feonn: feonnaData,
    mango: mangoData,
    sakori: sakoriData,
    sejal: sejalData,
    sagar: sagarData,
    vandana: vandanaData,
  };
  const teamDataMap2025 = {
    bellicosa: bellicosaData2025,
    carron: carronData2025,
    feonn: galaLegendsData2025,
    mango: mangoData2025,
    sakori: sakoriData2025,
    sejal: sejalData2025,
    sagar: sagarSeahawksData2025,
    vandana: vandanaData2025,
  };
  const teamKey = teamName.split(" ")[0].toLowerCase(); // "bellicosa"
  const teamData = is2025 ? teamDataMap2025[teamKey] : teamDataMap2024[teamKey];

  const teamImgMap = {
    bellicosa:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/bellicosa_team.jpeg",
    carron:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/carron_team.JPG",
    feonn:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/feon_team.jpg",
    mango:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/mango_team.png",
    sakori:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sakori_team.jpg",
    sejal:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sejal_team.jpg",
    sagar:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/sagar_sponsor.jpeg",
    vandana:
      "https://cdk-hnb659fds-assets-058264114439-ap-south-1.s3.ap-south-1.amazonaws.com/Vagad_League/teams/vandana_team.png",
  };
  const teamImg = teamImgMap[teamKey];
  console.log(teamImg);

  const scrollToTargetTopPlayer = () => {
    const targetPosition =
      targetRefTopPlayer.current.getBoundingClientRect().top +
      window.pageYOffset;
    const offsetPosition =
      targetPosition -
      window.innerHeight / 2 +
      targetRefTopPlayer.current.clientHeight / 2;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
    detailsTopPlayer.current.open = true;
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(teamName);
  }, [teamName, topPlayerId]);

  const openPhotoModalFunc = (photo) => {
    setIsModalOpen(true);
    setTeam_logo(photo);
  };

  const playerPoints = (prop) => {
    if (prop === undefined || prop === null) {
      return 0;
    }
    if (Array.isArray(prop)) {
      if (prop.length === 0) {
        return 0;
      }
      const first = prop[0];
      return first?.points ?? 0;
    }
    if (typeof prop === "object") {
      return prop.points ?? 0;
    }
    return prop;
  };

  const getPlayerMatchesPlayed = (person) => {
    const value = person?.matchesPlayed;

    if (value !== undefined && value !== null && value !== "") {
      return value;
    }

    return 0;
  };

  return (
    <>
      <div className="  px-6 py-24  lg:px-10 flex-shrink-0 relative overflow-hidden bg-teal-500 ">
        <PlayerModal
          isOpen={isModalOpen}
          onClose={closeModal}
          team_logo={team_logo}
        />

        <ul role="list" className="  md:p-5">
          <div className="flex-shrink-0 relative overflow-hidden bg-indigo-500 rounded-lg  shadow-lg pt-2 pb-5 px-2 my-8">
            <svg
              className="absolute bottom-0 left-0 mb-8"
              viewBox="0 0 375 283"
              fill="none"
              style={{ transform: "scale(1.5)", opacity: "0.1" }}
            >
              <rect
                x="159.52"
                y="175"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 159.52 175)"
                fill="white"
              />
              <rect
                y="107.48"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 0 107.48)"
                fill="white"
              />
              <rect
                y="107.48"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 100 107.48)" // Adjusted the rotation center
                fill="white"
              />
            </svg>
            <img
              src={teamImg}
              className="w-full md:hidden rounded-lg"
              width={100}
              height={100}
              onClick={() => setShowDetails(true)}
            />
            {/* <div className="relative pt-10 px-10 flex items-center justify-center"> */}

            <div
              align="center"
              className="text-white font-extrabold text-2xl mt-5"
            >
              {teamName}
            </div>
          </div>
          <div
            className="flex-shrink-0 relative overflow-hidden bg-indigo-900 rounded-t-lg  shadow-lg pt-2 pb-5 px-2 mt-4"
            onClick={() => scrollToTargetTopPlayer()}
          >
            <svg
              className="absolute bottom-0 left-0 mb-8"
              viewBox="0 0 375 283"
              fill="none"
              style={{ transform: "scale(1.5)", opacity: "0.1" }}
            >
              <rect
                x="159.52"
                y="175"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 159.52 175)"
                fill="white"
              />
              <rect
                y="107.48"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 0 107.48)"
                fill="white"
              />
              <rect
                y="107.48"
                width="152"
                height="152"
                rx="8"
                transform="rotate(-45 100 107.48)" // Adjusted the rotation center
                fill="white"
              />
            </svg>
            <div align="center" className="text-white font-extrabold text-2xl">
              Squad ({teamData?.length} players)
            </div>
          </div>
          {teamData?.map((person) => (
            <li
              key={person.id}
              className="flex w-full py-2"
              ref={person._id == topPlayerId ? targetRefTopPlayer : null}
            >
              <details
                className="group w-full"
                ref={person._id == topPlayerId ? detailsTopPlayer : null}
              >
                <summary className="flex items-center justify-between  p-2 font-medium w-full  py-5 group relative cursor-pointer overflow-hidden bg-white px-4  shadow-xl  transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl mx-auto rounded-lg">
                  <div
                    className="flex justify-between w-full"
                    onClick={() => setShowDetails(true)}
                  >
                    <div className="flex gap-5">
                      <ImageWithFallback
                        src={person?.photo}
                        fallbackSrc={DummyImg}
                        onClick={() => openPhotoModalFunc(person?.photo)}
                      />

                      <div className="min-w-0 flex-auto">
                        <p className="text-xl font-semibold leading-6 text-gray-900">
                          {person?.name}
                        </p>
                        <p className="mt-1 truncate text-sm leading-5 text-indigo-600">
                          {person?.position}
                        </p>
                      </div>
                    </div>
                  </div>
                  <svg
                    className="w-5 h-5 text-gray-500 transition group-open:rotate-90 self-center"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                    ></path>
                  </svg>
                </summary>
                <article className="mt-1 pb-4 ">
                  <ul className=" flex flex-col gap-2 px-4  p-2 font-medium w-full  py-5 group relative cursor-pointer overflow-hidden bg-white px-4  shadow-xl duration-300 hover:shadow-2xl mx-auto rounded-lg">
                    {person.cleanSheets?.length !== 0 && (
                      <li className="flex">
                        <img
                          src={cleenSheetImg}
                          width={30}
                          className="ml-2 mr-7"
                        />
                        <p className="mt-1 truncate text-md leading-5 font-semibold">
                          Clean sheets : {person?.cleanSheets}
                        </p>
                      </li>
                    )}
                    <li className="flex ">
                      <img src={goalsImg} width={30} className="ml-2 mr-7" />
                      <p className="mt-1 truncate text-md leading-5 font-semibold">
                        Goals Scored : {person?.goal_scored}{" "}
                      </p>
                    </li>
                    <li className="flex">
                      <img src={assistImg} width={30} className="ml-2 mr-7" />
                      <p className="mt-1 truncate text-md leading-5 font-semibold">
                        Assists : {person?.assists}
                      </p>
                    </li>

                    <li className="flex">
                      <img
                        src={yellowRedCardImg}
                        width={30}
                        className="ml-2 mr-7"
                      />
                      <p className="mt-1 truncate text-md leading-5 font-semibold">
                        Yellow Card : {person?.yellowCard}
                      </p>
                    </li>
                    <li className="flex">
                      <img
                        src={yellowRedCardImg}
                        width={30}
                        className="ml-2 mr-7"
                      />
                      <p className="mt-1 truncate text-md leading-5 font-semibold">
                        Red card : {person?.redCard}
                      </p>
                    </li>
                    <li className="flex">
                      <img src={pointsIcon} width={30} className="ml-2 mr-7" />
                      <p className="mt-1 truncate text-md leading-5 font-semibold">
                        Matches Played : {getPlayerMatchesPlayed(person)}
                      </p>
                    </li>
                    <li className="flex">
                      <img src={pointsIcon} width={30} className="ml-2 mr-7" />
                      <p className="mt-1 truncate text-md leading-5 font-semibold">
                        Player Points :{" "}
                        {playerPoints(person?.totalPoints)}
                      </p>
                    </li>
                  </ul>
                </article>
              </details>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default StaticEachTeam;

function ImageWithFallback({ src, fallbackSrc, ...props }) {
  const [imgSrc, setImgSrc] = useState(src);

  const onError = () => {
    setImgSrc(fallbackSrc);
  };

  return (
    <div className="relative">
      <img
        src={imgSrc}
        onError={onError}
        alt="Player img"
        className="h-12 w-12 flex-none rounded-full bg-gray-50"
        {...props}
      />
    </div>
  );
}
